import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private readonly selectedRegionIdSource = new BehaviorSubject<string | null>(this.defaultRegionId);
  selectedRegion$ = this.selectedRegionIdSource.asObservable();

  constructor() { }

  get(key: string) {
    return (environment as any)[key];
  }

  getRegionApplicationUrl(key: string) {
    return this.getRegionApplicationUrlForRegion(this.regionId, key);
  }

  getRegionApplicationUrlForRegion(regionId: string, key: string) {
    if (regionId === null || regionId === undefined) return null;
    return this.deploymentConfig.regions?.[regionId.toString()]?.endpoints?.[key] || null;
  }

  isMultiRegionEnabled() {
    return this.deploymentConfig.multiRegion === true && this.getAvailableRegions().length > 1;
  }

  /**
   * Creates a mapping of regionId to display name for all available regions.
   * @returns A lookup of the regionId -> regionName
   */
  getRegionDisplayLookup(): Record<string, string> {
    const availableRegions = this.getAvailableRegions();
    const regionDisplayLookup: Record<string, string> = {};
    availableRegions.forEach(regionId => {
      let regionConfig = this.deploymentConfig.regions?.[regionId];
      regionDisplayLookup[regionId] = regionConfig?.regionName ?? regionId;
    });
    return regionDisplayLookup;
  }

  getAvailableRegions(): string[] {
    return Object.keys(this.deploymentConfig.regions || {});
  }

  get regionId(): string {
    return this.selectedRegionIdSource.value ?? this.defaultRegionId;
  }

  setRegionId(regionId: string) {
    if (regionId === null || regionId === undefined) return;
    regionId = regionId.toString();
    if (!this.getAvailableRegions().includes(regionId)) return;

    if (this.selectedRegionIdSource.value !== regionId) {
      this.selectedRegionIdSource.next(regionId);
    }
  }

  private get defaultRegionId(): string {
    return this.deploymentConfig.defaultRegion.toString();
  }

  private get deploymentConfig() {
    return environment.deploymentConfig as any;
  }
}
